import React from 'react';
import { Button } from 'reactstrap';
import { FormPrecodedText } from './FormPrecodedText';
import { DeletePrecodedText } from './DeletePrecodedText';
import { Dialog } from 'primereact/dialog';

export const ModalPrecodedText = (props) => {
    const { modal, toggle, loading, method, id_type_precoded_text, text, typePrecodedTexts, handleInputChange, validaciones, saveCreate, saveUpdate, saveDelete } = props;
    const dialogTitle =
        method === "create"
            ? "Creación de texto precodificado"
            : method === "update"
                ? "Actualización de texto precodificado"
                : "Eliminar texto precodificado";

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
                color="secondary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                disabled={loading}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ?
                        <>
                            <i className="fa fa-spinner fa-spin mr-1"></i>
                            Guardando...
                        </>
                        :
                        "Guardar"
                }
            </Button>
            <Button
                color="danger"
                size="sm"
                onClick={toggle}
                disabled={loading}
            >
                Cancelar
            </Button>
        </div>
    );
    return (
        <Dialog
            //header={dialogTitle}
            visible={modal}
            onHide={toggle}
            dismissableMask={false}
            footer={footer}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-copy f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {dialogTitle}
                            </div>


                        </div>

                    </div>
                </div>
            }
            draggable={false}

            className={`Global-dialog Global-dialog Global-blue Global-small-v2`}

        >
            {method === "create" ? (
                <FormPrecodedText
                    button="Crear texto precodificado"
                    {...{
                        toggle,
                        id_type_precoded_text,
                        text,
                        typePrecodedTexts,
                        handleInputChange,
                        validaciones,
                        methodAction: saveCreate
                    }}
                />
            ) : method === "update" ? (
                <FormPrecodedText
                    button="Actualizar texto precodificado"
                    {...{
                        toggle,
                        loading,
                        id_type_precoded_text,
                        text,
                        typePrecodedTexts,
                        handleInputChange,
                        validaciones,
                        methodAction: saveUpdate
                    }}
                />
            ) : (
                <DeletePrecodedText {...{ toggle, loading, text, saveDelete }} />
            )}
        </Dialog>
    )
}
